import { subscribe, useSnapshot } from "valtio";
import { taskStore } from "./task-store";
import { AgmodalStore, bookingsStore, cargoStore, configStore, containerStore, contractsStore, EntityV2Store, loginStore } from "../state/CommonState";
import { Fragment, useEffect, useRef, useState } from "react";
import Utils from "../util/Utils";
import { TableComboInput, TableEdit, TableSelect } from "../components/AgComponents";
import { TableLabel } from "../v3-componets/AgTableLabel"
import chargedetails from "../assets/images/chargedetails.svg";
import { Card } from "../v3-componets/AgCard"
import { Headspan } from "../v3-componets/AgHeadspan"
import { chargesData1, currencyList } from "../StaticData";
import { airChargesBookingStore, chargesBookingStore1, chargesBookingValidationStore, fclChargesBookingStore } from "../mybooksv3/booking-commonstate";
import AiChargeParse, { fillChargesStore, AiChargeHistory, loadAiHistory, getAiHistory } from "../components/AiChargeParse";
import QuoteCalcV2 from "../util/quote-calc-v2";
import { loader } from "../util/loader";
import Taskapi from "./tasks-api";
import MonApi, { GET_SH_ENTITIES_SORTED_BY_NAME_URI, INSERT_ONE_MYACTION_URI, REPLACE_MYACTION_URI } from '../state/mongo-api';
import TaskDatetime from "./task-datetime";
import Taskfiletable from "./task-file-table";
import Taskfiledisplay from "./task-file-display";
import FCLChargeClientViewv3 from "../enquiryv3/FCLChargeClientView-v3";
import AirChargesClientViewv3 from "../enquiryv3/AirChargesClientView-v3";
import LCLChargeClientViewv3 from "../enquiryv3/LCLChargeClientView-v3";
import ReactDOMServer from "react-dom/server";
import { groupedByCategory, PRICING_CATEGORY } from "../charges_data/LCLCharges";
import TenantUtils from "../util/tenant.utils";
import RoleUtils from "../util/RoleUtils";
import { PERMISSIONS_NEW } from "../util/constants";
import { QuoteCharges1 } from "../state/Types";

const UpdateCostTableSelect = (props) => {
    const { record, name } = props
    if (name === "currency" && record[name] !== undefined && record[name].trim().length > 0 && record["currencyinr"] === undefined) {
        record["currencyinr"] = configStore.getExchangeRate(record[name])
    }
    return <TableSelect {...props} setCurrencyInr={false} />
}

export default function UpdateCost(props) {
    useSnapshot(taskStore)
    useSnapshot(contractsStore)
    // AI charge history of this Update Cost action: loaded per booking, saved with the action (save below)
    const aiHistoryKey = taskStore.current?.bookingNum || bookingsStore.current?._id || ""
    useEffect(() => { loadAiHistory("updateCost", aiHistoryKey, taskStore.current?.aiChargeHistory) }, [aiHistoryKey])
    const [fetchbtn, setFetchbtn] = useState(false)
    let stage = taskStore.current.stage
    console.log(taskStore.current, stage)

    const FPR = (type) => {
        if (type.indexOf("FCL") >= 0) {
            type = "FCL"
        }
        const addcharge = (cl) => {
            contractsStore.current.chargesList.map((e) => {
                let k = Object.keys(e)
                let k1 = true
                cl.map((e1, i) => {
                    if (e1['chargeDescription'] == e['chargeDescription']) {
                        k1 = false
                        k.map((ek) => {
                            if (ek != 'id') {
                                cl[i][ek] = e[ek]
                            }
                        })
                    }
                })
                if (k1) {
                    cl.push(e)
                    cl[cl.length - 1]['id'] = cl.length + 1
                }
            })
            return cl?.filter(e => e?.chargeDescription && e?.chargeDescription.trim() !== "")
        }
        if (type.indexOf("FCL") >= 0) {
            let l = addcharge(JSON.parse(JSON.stringify(fclChargesBookingStore.list)))
            fclChargesBookingStore.initialLength = l.length;
            fclChargesBookingStore.list = JSON.parse(JSON.stringify(l));
        } else if (type.indexOf("Air") >= 0) {
            let l = addcharge(JSON.parse(JSON.stringify(airChargesBookingStore.list)))
            airChargesBookingStore.initialLength = l.length;
            airChargesBookingStore.list = JSON.parse(JSON.stringify(l));
        } else {
            let l = addcharge(JSON.parse(JSON.stringify(chargesBookingStore1.list)))
            l = Utils.groupedCategoryChargeList({ chargeList: l })
            chargesBookingStore1.initialLength = l.length;
            chargesBookingStore1.list = JSON.parse(JSON.stringify(l));
        }
        setFetchbtn(false)
    }

    const changeShipmentTypes = (type) => {
        if (type.indexOf("FCL") >= 0) {
            type = "FCL"
        }
        const data1 = chargesData1[type.toLowerCase()];
        if (data1 && data1.initialLength) {
            if (type.indexOf("FCL") >= 0) {
                fclChargesBookingStore.colNames = data1.colNames;
                fclChargesBookingStore.initialLength = data1.initialLength;
                fclChargesBookingStore.list = data1.preList;
                fclChargesBookingStore.list = fclChargesBookingStore.list.map((ele, index) => {
                    return { ...ele, currency: data1.preList[index].currency }
                })
            } else if (type.indexOf("Air") >= 0) {
                airChargesBookingStore.initialLength = data1.initialLength;
                airChargesBookingStore.list = data1.preList;
                airChargesBookingStore.list = airChargesBookingStore.list.map((ele, index) => {
                    return { ...ele, currency: data1.preList[index].currency }
                })
            } else {
                chargesBookingStore1.initialLength = data1.initialLength;
                chargesBookingStore1.list = data1.preList;
                chargesBookingStore1.list = chargesBookingStore1.list.map((ele, index) => {
                    return { ...ele, currency: data1.preList[index].currency }
                });
            }
        }
    }
    const save = async (type) => {
        let l = JSON.parse(JSON.stringify(taskStore.current))
        l["aiChargeHistory"] = getAiHistory("updateCost")
        l['containerList'] = JSON.parse(JSON.stringify(contractsStore.current.containerList))
        l['cargoList'] = JSON.parse(JSON.stringify(contractsStore.current.cargoList))
        chargesBookingValidationStore.isNew = false
        let chargeStoreToValidate;
        if (type.indexOf("FCL") >= 0) {
            type = "FCL"
        }
        if (type.indexOf("FCL") >= 0) {
            fclChargesBookingStore.calculateChargesTotalsindex("list", contractsStore.current.emptycontainerweight);
            chargeStoreToValidate = fclChargesBookingStore;
        } else if (type.indexOf("Air") >= 0) {
            airChargesBookingStore.checktotal = airChargesBookingStore.checktotal + 1
            cargoStore.calculateCargoTotals()
            airChargesBookingStore.calculateChargesTotalsindex('list')
            chargeStoreToValidate = airChargesBookingStore;
        } else {
            chargesBookingStore1.checktotal = chargesBookingStore1.checktotal + 1
            cargoStore.calculateCargoTotals()
            chargesBookingStore1.calculateLCLChargesTotals()
            chargeStoreToValidate = chargesBookingStore1
        }
        if (type.indexOf("Air") == -1) {
            let cd = []
            let scope = contractsStore.current.shipmentScope.split('-to-')
            if (scope[0] == 'Door') {
                cd.push('Origin Transport Rates')
            }
            if (scope[1] == 'Door') {
                cd.push('Destination Transport Rates')
            }
            if (type.indexOf("FCL") >= 0) {
                cd.push('Ocean Freight')
            }
            if (cd.length > 0) {
                let ef = []
                let f = l.files
                for (let i = 0; i < f.length; i++) {
                    if (cd.indexOf(f[i].label) != -1 && f[i].filename.length == 0) {
                        ef.push(f[i].label)
                    }
                }
                if (ef.length > 0) {
                    configStore.setModalMessage(`${ef[0]} Document Requried`);
                    return false;
                }
            }
        }
        if (type.indexOf("FCL") >= 0) {
            let kz = true
            if (chargeStoreToValidate && containerStore.list.length > 0) {
                containerStore.list.map((container) => {
                    chargeStoreToValidate.list.map((charge, index) => {
                        if (kz) {
                            kz = chargesBookingValidationStore.isValidCharge(
                                `${container.containerType}perWM`,
                                index,
                                'list'
                            )
                        }
                    })
                })
            }
            if (!kz) {
                configStore.setModalMessage(`Please check the charges detail fields`);
                return false;
            }
        } else if(type.indexOf("Air") >= 0){
            let kz = true
            if (chargeStoreToValidate &&
                !chargeStoreToValidate.list.every((charge, index) =>
                    Object.keys(charge).every((chargeKey) =>
                        chargesBookingValidationStore.isValidCharge(chargeKey, index)
                    ))
            ) {
                kz = false
            }
            if (!kz) {
                configStore.setModalMessage(`Please check the charges detail fields`);
                return false;
            }
        } else {
            let kz = true
            if (chargeStoreToValidate &&
                !chargeStoreToValidate.list.every((charge, index) =>
                    Object.keys(charge).every((chargeKey) =>
                        chargesBookingValidationStore.isValidChargelclform(chargeKey, index, chargeStoreToValidate.list)
                    ))
            ) {
                kz = false
            }
            if (!kz) {
                configStore.setModalMessage(`Please check the charges detail fields`);
                return false;
            }
        }
        l['chargesList'] = JSON.parse(JSON.stringify(chargeStoreToValidate.list))
        let k = new QuoteCalcV2(l).recalc()
        l['quoteValue'] = k.quoteValue
        l['quoteValueUSD'] = k.quoteValueUSD
        l['profit'] = (+contractsStore.current.quoteValue) - k.quoteValue
        l['profit_percentage'] = (l['profit'] / (+contractsStore.current.quoteValue)) * 100
        if (k.quoteValue != 0) {
            l.chargesList = l.chargesList.filter(e => e.chargeDescription && e.currency);
            taskStore.current = l
            let entity = EntityV2Store.list.find((e) => e.entityId === contractsStore.current.entityId)
            const salesVertical = entity?.customer?.crossBorder?.salesVertical
            let msme = false
            if (salesVertical != undefined && salesVertical === "MSME") {
                msme = true
            }
            if (msme && contractsStore.current.shipmentType.includes("FCL") && process.env.REACT_APP_PROFIT_MSME_MARGIN != undefined && taskStore.current['profit_percentage'] < Number(process.env.REACT_APP_PROFIT_MSME_MARGIN)) {
                taskStore.modalVisible = true
            } else if (!msme && contractsStore.current.shipmentType.includes("FCL") && process.env.REACT_APP_PROFIT_MARGIN != undefined && taskStore.current['profit_percentage'] < Number(process.env.REACT_APP_PROFIT_MARGIN)) {
                taskStore.modalVisible = true
            } else if (contractsStore.current.shipmentType.includes("FCL") && l['profit_percentage'] >= 20) {
                taskStore.modal1Visible = true
            } else {
                loader.show()
                taskStore.current.stage = 2
                taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
                taskStore.setComplete()
                //taskStore.setCustomerComplete()
                taskStore.current.approve = true
                let booking = { ...bookingsStore.current }
                taskStore.current.bookingNum = booking._id
                if (taskStore.current._id != undefined && taskStore.current._id.length == 0) {
                    let nextNum = await Taskapi.getNextNum()
                    taskStore.current._id = {
                        bookingNum: booking._id,
                        num: nextNum
                    }
                    taskStore.current.updatelist = [
                        {
                            updatedOn: Date.now(),
                            updatedBy: loginStore.email,
                            status: "created"
                        }
                    ]
                    await MonApi.apost(INSERT_ONE_MYACTION_URI, taskStore.current)
                } else {
                    let u = {
                        updatedOn: Date.now(),
                        updatedBy: loginStore.email,
                        status: "updated"
                    }
                    taskStore.current.updatelist.push(u)
                    taskStore.current.updatelist.sort((a, b) => {
                        return b.updatedOn - a.updatedOn
                    })
                    await MonApi.apost(REPLACE_MYACTION_URI, taskStore.current)
                }
                loader.hide()
                Taskapi.sendActionAgragaTriggerEmail()
                taskStore.triggerActionVisible = false
                taskStore.myActionVisible = false
                if (AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()) {
                    AgmodalStore.pageVisible = false
                    AgmodalStore.apiCall = true
                    AgmodalStore.modalPage = "ViewEnquiryBooking-v3"
                }
            }

        } else {
            configStore.setModalMessage(`On your account is empty.`);
        }
    }

    useEffect(() => {
        if (stage != undefined && stage == 1) {
            let type = contractsStore.current.shipmentType
            let scope = contractsStore.current.shipmentScope.split('-to-')
            if (taskStore.current.files == undefined) {
                taskStore.current.files = []
            }
            let l = []
            let f = taskStore.current.files
            for (let i = 0; i < f.length; i++) {
                l.push(f[i].label)
            }
            console.log(l, f, type, scope)
            if (type.indexOf("Air") == -1) {
                if (scope[0] == 'Door' && l.indexOf('Origin Transport Rates') == -1) {
                    taskStore.current.files.push({
                        "label": "Origin Transport Rates",
                        "filename": "",
                        "approved": "",
                        "rejectReason": ""
                    })
                }
                if (scope[1] == 'Door' && l.indexOf('Destination Transport Rates') == -1) {
                    taskStore.current.files.push({
                        "label": "Destination Transport Rates",
                        "filename": "",
                        "approved": "",
                        "rejectReason": ""
                    })
                }
                if (type.indexOf("FCL") >= 0 && l.indexOf('Ocean Freight') == -1) {
                    taskStore.current.files.push({
                        "label": "Ocean Freight",
                        "filename": "",
                        "approved": "",
                        "rejectReason": ""
                    })
                }
            }
            console.log(l, taskStore.current.files, type, scope)
            if (JSON.stringify(containerStore.list) != JSON.stringify(contractsStore.current.containerList)) {
                containerStore.list = JSON.parse(JSON.stringify(contractsStore.current.containerList))
            }
            if (JSON.stringify(cargoStore.cargoList) != JSON.stringify(contractsStore.current.cargoList)) {
                cargoStore.cargoList = JSON.parse(JSON.stringify(contractsStore.current.cargoList))
            }
            let c = taskStore.current.chargesList
            if (c != undefined && c.length == 0) {
                chargesBookingValidationStore.isNew = true
                changeShipmentTypes(contractsStore.current.shipmentType)
                setFetchbtn(true)
            } else {
                if (type.indexOf("FCL") >= 0) {
                    type = "FCL"
                }
                let k = JSON.parse(JSON.stringify(c))
                if (type.indexOf("FCL") >= 0 && JSON.stringify(fclChargesBookingStore.list) != JSON.stringify(k)) {
                    fclChargesBookingStore.initialLength = k.length;
                    fclChargesBookingStore.list = k;
                } else if (type.indexOf("Air") >= 0 && JSON.stringify(airChargesBookingStore.list) != JSON.stringify(k)) {
                    airChargesBookingStore.initialLength = k.length;
                    airChargesBookingStore.list = k;
                } else if (JSON.stringify(chargesBookingStore1.list) != JSON.stringify(k)) {
                    k = Utils.groupedCategoryChargeList({ chargeList: k })
                    chargesBookingStore1.initialLength = k.length;
                    chargesBookingStore1.list = k;
                }
            }
        }
    }, [JSON.stringify(taskStore.current)])
    return (<>
        {
            (taskStore.modalVisible) ? <Profitmodal /> : ""
        }
        {
            (taskStore.modal1Visible) ? <Marginmodal /> : ""
        }

        {
            (stage != undefined && stage == 1) ? <>
                <Taskfiletable nonEditable={true} notshow={true} />
                {
                    (fetchbtn && (bookingsStore?.current?.createdFromPricing == undefined || bookingsStore.current.createdFromPricing == false)) ? <><br />
                        <button className="button islink" onClick={(e) => {
                            FPR(contractsStore.current.shipmentType)
                        }}>Fetch Sell Rates</button></> : ""
                }
                {contractsStore.current.shipmentType.indexOf("LCL") >= 0 ? (
                    <LCLChargesComp />
                ) : (
                    <></>
                )}
                {contractsStore.current.shipmentType.indexOf("Air") >= 0 ? (
                    <AirChargesComp />
                ) : (
                    <></>
                )}
                {contractsStore.current.shipmentType.indexOf("FCL") >= 0 ? (
                    <FCLChargesComp />
                ) : (
                    <></>
                )}
                <br />
                <button className="button islink" onClick={(e) => {
                    save(contractsStore.current.shipmentType)
                }}>Save</button>
            </> : <>
                <Taskfiledisplay notshow={true} validation={true} />
                {
                    (contractsStore.current.shipmentType.indexOf("FCL") >= 0) ? <FCLChargeClientViewv3 dummyContract={taskStore.current} /> : <>
                        {
                            (contractsStore.current.shipmentType.indexOf("Air") >= 0) ? <AirChargesClientViewv3 dummyContract={taskStore.current} /> :
                                <LCLChargeClientViewv3 dummyContract={taskStore.current} />
                        }
                    </>
                }
            </>
        }
    </>)
}

export function UpdateCostTrigger(props) {
    useSnapshot(taskStore)
    useSnapshot(configStore)
    const [disableButton, setDisableButton] = useState(true)
    useEffect(() => {
        let unsubscribe = subscribe(taskStore.current, () => {
            if (taskStore.current.dueDate.length > 0) {
                setDisableButton(false)
            } else {
                setDisableButton(true)
            }
        })
        return unsubscribe
    }, [taskStore.current])
    return (
        <>
            <TaskDatetime />
            <br /><br /><br />
            <p>
                <button className="button islink"
                    disabled={disableButton}
                    onClick={async (e) => {
                        taskStore.current.stage = 1
                        taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
                        taskStore.current.status = 'PENDING'
                        //await Taskapi.getEmailsForEntity(taskStore.current.gst)
                        setDisableButton(true)
                        if (taskStore.current._id != undefined && taskStore.current._id.length == 0) {
                            await Taskapi.saveTask(taskStore.current)
                        } else {
                            let u = {
                                updatedOn: Date.now(),
                                updatedBy: loginStore.email,
                                status: "updated"
                            }
                            taskStore.current.updatelist.push(u)
                            taskStore.current.updatelist.sort((a, b) => {
                                return b.updatedOn - a.updatedOn
                            })
                            await MonApi.apost(REPLACE_MYACTION_URI, taskStore.current)
                            Taskapi.sendActionAgragaTriggerEmail()
                        }
                        taskStore.triggerActionVisible = false
                        taskStore.myActionVisible = false
                    }}>Trigger Action</button>
            </p>
        </>
    )
}

export function Profitmodal(props) {
    useSnapshot(AgmodalStore)
    useSnapshot(taskStore)
    useSnapshot(bookingsStore)
    useSnapshot(contractsStore)
    let modalClass = 'modal'
    if (taskStore.modalVisible) modalClass += ' is-active'
    return (
        <div className={modalClass} onClick={() => { taskStore.modalVisible = false }}>
            <div className="modal-background" ></div>
            <div className="modal-card" onClick={(e) => { e.stopPropagation() }}
                style={{ borderRadius: '10px' }}>

                <section className="modal-card-body" style={{ textAlign: 'center' }}>
                    <button className="delete" style={{ float: 'right' }}
                        onClick={() => { taskStore.modalVisible = false }}></button>
                    <div><strong>Please confirm before Submitting the same. The Gross Profit on this Booking is INR {taskStore.current['profit'].toFixed(2)} | {taskStore.current['profit_percentage'].toFixed(2)}%. The same might be subject to Approval</strong></div>


                    <div>
                        <button className="button is-small is-link" style={{ float: 'left' }}
                            onClick={() => {
                                taskStore.modalVisible = false
                            }}>
                            Close
                        </button>
                        <button className="button is-small is-link" style={{ float: 'right' }}
                            onClick={async () => {
                                loader.show()
                                taskStore.current.stage = 2
                                taskStore.current.approve = false
                                taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
                                taskStore.setComplete()
                                //taskStore.setCustomerComplete()
                                let booking = { ...bookingsStore.current }
                                taskStore.current.bookingNum = booking._id
                                if (taskStore.current._id != undefined && taskStore.current._id.length == 0) {

                                    let nextNum = await Taskapi.getNextNum()
                                    taskStore.current._id = {
                                        bookingNum: booking._id,
                                        num: nextNum
                                    }
                                    taskStore.current.updatelist = [
                                        {
                                            updatedOn: Date.now(),
                                            updatedBy: loginStore.email,
                                            status: "created"
                                        }
                                    ]
                                    await MonApi.apost(INSERT_ONE_MYACTION_URI, taskStore.current)
                                } else {
                                    let u = {
                                        updatedOn: Date.now(),
                                        updatedBy: loginStore.email,
                                        status: "updated"
                                    }
                                    taskStore.current.updatelist.push(u)
                                    taskStore.current.updatelist.sort((a, b) => {
                                        return b.updatedOn - a.updatedOn
                                    })
                                    await MonApi.apost(REPLACE_MYACTION_URI, taskStore.current)
                                }
                                let entity = EntityV2Store.list.find((e) => e.entityId === contractsStore.current.entityId)
                                const salesVertical = entity?.customer?.crossBorder?.salesVertical
                                let msme = false
                                if (salesVertical != undefined && salesVertical === "MSME") {
                                    msme = true
                                }
                                if ((!msme && process.env.REACT_APP_PROFIT_MARGIN != undefined && taskStore.current['profit_percentage'] < Number(process.env.REACT_APP_PROFIT_MARGIN) && process.env.REACT_APP_PROFIT_ALERT != undefined) || (msme && process.env.REACT_APP_PROFIT_MSME_MARGIN != undefined && taskStore.current['profit_percentage'] < Number(process.env.REACT_APP_PROFIT_MSME_MARGIN) && process.env.REACT_APP_PROFIT_MSME_ALERT != undefined)) {
                                    let data = await MonApi.apost(`${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/listuserIds`, { entityId: taskStore.current.entityId, branchId: bookingsStore.current.branchId })
                                    let customer = data?.shEntitiesCustomer[0]?.customer;
                                    let rm = Utils.getRM(customer)
                                    let cc = "";
                                    let from = `Actions ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} ${process.env.REACT_APP_MYACTIONSEMAIL_ID.split('@')[0] + '@' + process.env.REACT_APP_ENTERPRISE_DOMAIN}>`
                                    let to = !msme ? process.env.REACT_APP_PROFIT_ALERT : process.env.REACT_APP_PROFIT_MSME_ALERT
                                    let subject = "Approval Required: Low Margin/Loss Detected for " + booking._id
                                    let charge = ReactDOMServer.renderToString(
                                        <>
                                            <hr />
                                            <p><strong>Sell Charges</strong></p>

                                            {
                                                (contractsStore.current.shipmentType.indexOf("FCL") >= 0) ? <FCLChargeClientViewv3 dummyContract={contractsStore.current} /> : <>
                                                    {
                                                        (contractsStore.current.shipmentType.indexOf("Air") >= 0) ? <AirChargesClientViewv3 dummyContract={contractsStore.current} /> :
                                                            <LCLChargeClientViewv3 dummyContract={contractsStore.current} />
                                                    }
                                                </>
                                            }
                                            <hr />
                                            <p><strong>Cost Charges</strong></p>
                                            {
                                                (contractsStore.current.shipmentType.indexOf("FCL") >= 0) ? <FCLChargeClientViewv3 dummyContract={taskStore.current} /> : <>
                                                    {
                                                        (contractsStore.current.shipmentType.indexOf("Air") >= 0) ? <AirChargesClientViewv3 dummyContract={taskStore.current} /> :
                                                            <LCLChargeClientViewv3 dummyContract={taskStore.current} />
                                                    }
                                                </>
                                            }
                                            <hr />
                                        </>
                                    )
                                    let ename = await MonApi.apost(GET_SH_ENTITIES_SORTED_BY_NAME_URI, {
  "_id": taskStore.current.entityId
})
                                    if (ename.length > 0) {
                                        ename = ename[0]['entityName']
                                    }
                                    let message = `<p>
    Hi,<br>
    A shipment has been flagged for low margin or potential loss. Please review and approve based on the following details<br>
    Shipment Details:<br>
    • ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking Ref: ${taskStore.current.bookingNum}<br>
    • Customer: ${ename}<br>
    • Mode: ${taskStore.current.shipmentType}<br>
    • Origin - Destination: ${taskStore.current.origin} → ${taskStore.current.destination}<br>
    • POL - FPOD: ${bookingsStore.current.contract.portOfReceipt} → ${taskStore.current.fpod}<br>
    • Relationship Manager: ${rm}<br><br>
    <strong>Charges Details</strong>:<br>`+ charge +
                                        `<br>Approval Type - Low Margin/ Loss<br>
    Margin Amout : ${taskStore.current['profit'].toFixed(2)}<br>
    Percentage : ${taskStore.current['profit_percentage'].toFixed(2)}%<br>
    Please <a href="<<server>>/myactions/${taskStore.current.bookingNum}ACTLINGACTApproval for loss">Click here</a> complete this action.<br>
    Regards,<br>
    Product Team<br>
    ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}
</p>`
                                    if(customer?.crossBorder?.salesVertical?.trim() == 'MSME' && booking?.contract?.customerReferenceNum) subject = subject+'// CRN: '+ booking?.contract?.customerReferenceNum
                                    const doc = {
                                        from, to, cc, subject, message, bookingNum: taskStore.current.bookingNum
                                    }
                                    let url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/sendclientactionmail`
                                    await MonApi.apost(url, doc)
                                    let l = JSON.parse(JSON.stringify(taskStore.current))
                                    let nextNum = await Taskapi.getNextNum()
                                    l._id = {
                                        bookingNum: booking._id,
                                        num: nextNum
                                    }
                                    l.updatelist = [
                                        {
                                            updatedOn: Date.now(),
                                            updatedBy: loginStore.email,
                                            status: "created"
                                        }
                                    ]
                                    l.actionName = "Approval for loss"
                                    l.stage = 1
                                    l.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
                                    l.status = 'PENDING'
                                    l.createdOn = Date.now()
                                    l.updatedOn = Date.now()
                                    l.createdBy = loginStore.email
                                    l.completedOn = ""
                                    l.completedBy = ""
                                    await MonApi.apost(INSERT_ONE_MYACTION_URI, l)
                                }
                                loader.hide()
                                taskStore.modalVisible = false
                                taskStore.triggerActionVisible = false
                                taskStore.myActionVisible = false
                                if (AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()) {
                                    AgmodalStore.pageVisible = false
                                    AgmodalStore.apiCall = true
                                    AgmodalStore.modalPage = "ViewEnquiryBooking-v3"
                                }

                            }}>
                            Confirm
                        </button>

                    </div>
                </section>
            </div>
        </div>
    )
}

export function Marginmodal(props) {
    useSnapshot(AgmodalStore)
    useSnapshot(taskStore)
    useSnapshot(bookingsStore)
    let modalClass = 'modal'
    if (taskStore.modal1Visible) modalClass += ' is-active'
    return (
        <div className={modalClass} onClick={() => { taskStore.modal1Visible = false }}>
            <div className="modal-background" ></div>
            <div className="modal-card" onClick={(e) => { e.stopPropagation() }}
                style={{ borderRadius: '10px' }}>

                <section className="modal-card-body" style={{ textAlign: 'center' }}>
                    <button className="delete" style={{ float: 'right' }}
                        onClick={() => { taskStore.modal1Visible = false }}></button>
                    <div><strong>The margin for this transaction is currently over {taskStore.current['profit_percentage'].toFixed(2)}%. Kindly review the buy and sell rates before to avoid future mistakes.</strong></div>


                    <div>
                        <button className="button is-small is-link" style={{ float: 'left' }}
                            onClick={() => {
                                taskStore.modal1Visible = false
                            }}>
                            No
                        </button>
                        <button className="button is-small is-link" style={{ float: 'right' }}
                            onClick={async () => {
                                loader.show()
                                taskStore.current.stage = 2
                                taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
                                taskStore.setComplete()
                                //taskStore.setCustomerComplete()
                                let booking = { ...bookingsStore.current }
                                taskStore.current.bookingNum = booking._id
                                if (taskStore.current._id != undefined && taskStore.current._id.length == 0) {
                                    let nextNum = await Taskapi.getNextNum()
                                    taskStore.current._id = {
                                        bookingNum: booking._id,
                                        num: nextNum
                                    }
                                    taskStore.current.updatelist = [
                                        {
                                            updatedOn: Date.now(),
                                            updatedBy: loginStore.email,
                                            status: "created"
                                        }
                                    ]
                                    await MonApi.apost(INSERT_ONE_MYACTION_URI, taskStore.current)
                                } else {
                                    let u = {
                                        updatedOn: Date.now(),
                                        updatedBy: loginStore.email,
                                        status: "updated"
                                    }
                                    taskStore.current.updatelist.push(u)
                                    taskStore.current.updatelist.sort((a, b) => {
                                        return b.updatedOn - a.updatedOn
                                    })
                                    await MonApi.apost(REPLACE_MYACTION_URI, taskStore.current)
                                }
                                loader.hide()
                                taskStore.modal1Visible = false
                                taskStore.triggerActionVisible = false
                                taskStore.myActionVisible = false
                                if (AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()) {
                                    AgmodalStore.pageVisible = false
                                    AgmodalStore.apiCall = true
                                    AgmodalStore.modalPage = "ViewEnquiryBooking-v3"
                                }

                            }}>
                            Yes, Entered Data is correct
                        </button>

                    </div>
                </section>
            </div>
        </div>
    )
}

export function LCLChargesCompV5() {
    const [grandTotal, setGrandTotal] = useState(0.0)
    const [shipTotal, setShipTotal] = useState(0.0)
    const [conTotal, setConTotal] = useState(0.0)
    const onaccount = ['On Your Account', `Consignee's Account`, `Shipper's Account`]
    const [volumeDiscount, setVolumeDiscount] = useState(0)
    const [showtotal, setShowtotal] = useState(false)

    useSnapshot(cargoStore)
    useSnapshot(contractsStore)
    console.log('ChargesComp rendering')
    let [space, setSpace] = useState('')

    let imChargesStore = useSnapshot(chargesBookingStore1)

    useEffect(() => {
        let list = chargesBookingStore1.list
        for (let i = 0; i < list.length; i++) {
            if (!list[i].onaccount || !list[i].onaccount.length) list[i].onaccount = 'On Your Account'
        }
        if (!grandTotal) {
            calculateFinalTotal()
            let vd = chargesBookingStore1.list.find(e => e.chargeDescription == 'Volume Discount')
            if (vd) {
                let of = chargesBookingStore1.list.filter(e => e.chargeDescription == 'Ocean Freight')
                if (of && of.length) {
                    if (vd.total > 0) vd.total *= -1
                    let voldis = vd.total
                    let e = of[0]
                    if (e.perCBM > 0 ||
                        e.perTon > 0 ||
                        e.minimum > 0 ||
                        e.maximum > 0 ||
                        e.perShipment > 0) {
                        e.perShipment = (e.total > 0 ? e.total : e.total * -1) + voldis
                        if (e.perShipment > 0) e.perShipment *= -1
                        console.log('\n\n\nSetting pershipment of OF to', e.perShipment, '\n-----------\n')
                    }
                }
            }
        }
    }, [imChargesStore])
    useEffect(() => {
        setVolumeDiscount(0)
        cargoStore.calculateCargoTotals()
        imChargesStore.calculateLCLChargesTotals()
        calculateFinalTotal()
    }, [imChargesStore.checktotal])
    useEffect(() => {
        let entity = EntityV2Store.list.find((e) => e.entityId === contractsStore.current.entityId)
        if (entity) {
            let sscope = contractsStore.current.shipmentScope
            sscope = sscope.toLowerCase()
            let country = '' + entity.entityCountry
            country = country.toLowerCase()
            let cecisorigin = false
            let cecisdestination = false
            let por = ('' + contractsStore.current.portOfLoading).toLowerCase()
            let pod = ('' + contractsStore.current.finalPlaceOfDelivery).toLowerCase()
            let q = contractsStore.current
            if (entity._id == "TBA" && q.isfromAgragaEnquiry != undefined && q.isfromAgragaEnquiry == 'Yes' && q.countryFromEnquiry != undefined) {
                country = q.countryFromEnquiry.toLowerCase()
            }
            if (country.includes('hong kong')) {
                cecisorigin = por.includes('hong kong')
                cecisdestination = pod.includes('hong kong')
            } else {
                cecisorigin = por.includes(country)
                cecisdestination = pod.includes(country)
            }

            chargesBookingStore1.list.map((e) => {
                if (sscope.length != 0 && country.length != 0 && por.length != 0 && pod.length != 0) {
                    if (e.onaccount != undefined) {
                        if (onaccount.indexOf(e.onaccount) == -1) {
                            e.onaccount = "On Your Account"
                        }
                    }
                }
                return e
            })
        }
        console.log('DETECTED CHANGES=', contractsStore.current.entityId, contractsStore.current.portOfReceipt, contractsStore.current.portOfDischarge)
    }, [
        contractsStore.current.entity, contractsStore.current.entityId, contractsStore.current.portOfLoading,
        contractsStore.current.finalPlaceOfDelivery, contractsStore.current.shipmentScope
    ])
    const deleteRec = (id) => {
        //if (id <= imChargesStore.initialLength) return
        const index = chargesBookingStore1.list.findIndex(e => e.id === id)
        let records = chargesBookingStore1.list
        records = [...records]
        records.splice(index, 1)
        for (let i = 0; i < records.length; i++) {
            records[i].id = i + 1
        }
        if (id <= chargesBookingStore1.initialLength) {
            chargesBookingStore1.initialLength = chargesBookingStore1.initialLength - 1
        }
        chargesBookingStore1.list = records
        if (chargesBookingStore1.list.length == 0) {
            let obj = imChargesStore.newRec
            obj = { ...obj }
            chargesBookingStore1.list.push({ ...obj, id: chargesBookingStore1.list.length + 1 })
        }
        //console.log('AFTER DELETE=', JSON.stringify(chargesBookingStore1.cargoList))
    }
    const Ts = ({ i, name, dataList, ...otherProps }) => <TableSelect
        record={chargesBookingStore1.list[i]} name={name} dataList={dataList} isValid={chargesBookingValidationStore.isValidCharge(name, i)} {...otherProps} />
    const Te = ({ i, name }) => {
        const e = chargesBookingStore1.list[i]
        if ((name === 'chargeDescription' && i < chargesBookingStore1.initialLength) || e.chargeDescription == 'Volume Discount') {
            return <TableLabel record={chargesBookingStore1.list[i]} name={name} />
        } else {
            return <TableComboInput
                record={chargesBookingStore1.list[i]} name={name} dataList={configStore.getChargeDescriptionList('lcl')} isValid={chargesBookingValidationStore.isValidCharge(name, i)} />
            // return <TableEdit isblue={true} callback={(e)=>{chargesBookingStore1.list[i][name]=e}}  record={chargesBookingStore1.list[i]} name={name} isValid={chargesBookingValidationStore.isValidCharge(name, i)}/>
        }

    }
    const Tn = ({ i, name, ...otherProps }) => {
        const e = chargesBookingStore1.list[i]
        if ((e.disabled && e.disabled.indexOf(name) >= 0) || e.chargeDescription == 'Volume Discount')
            return (
                <input disabled='true' style={{ width: '3rem', backgroundColor: '#dddddd', border: 'none' }} />
            )
        else return (
            <TableEdit record={chargesBookingStore1.list[i]} name={name} type='number' isValid={chargesBookingValidationStore.isValidCharge(name, i)} {...otherProps} />
        )
    }
    const ifNotFCL = () => contractsStore.current.shipmentType.indexOf('FCL') < 0

    let finalTotal = 0.0
    const calculateFinalTotal = () => {
        let tot = 0
        let shiptot = 0
        let contot = 0
        chargesBookingStore1.list.map((e) => {
            let erate = configStore.getExchangeRateinr(e)
            if (!erate || erate === 0) erate = 1.0
            if (e.chargeDescription == 'Volume Discount') {
                if (e.total > 0) e.total *= -1
                setVolumeDiscount(e.total * erate)
            } else {
                if (e.onaccount && e.onaccount.startsWith('Cons')) contot += e.total * erate
                else if (e.onaccount && e.onaccount.startsWith('Ship')) shiptot += e.total * erate
                else {
                    tot += e.total * erate
                }
            }
        })
        if (tot && showtotal == false) {
            setShowtotal(true)
        }
        setGrandTotal(tot)
        setShipTotal(shiptot)
        setConTotal(contot)
        return finalTotal;
    }

    return (
        <>
            <hr />
            <Card onClick={(e) => {
                e.nativeEvent.preventDefault()
                e.preventDefault()
                e.nativeEvent.stopPropagation()
                e.stopPropagation()

            }}>
                <span><img src={chargedetails} /></span><Headspan color="#00000" fontSize="14px" fontWeight="900" data=" Charge Details" />
                <AiChargeParse historyScope="updateCost" historyKey="list" shipmentType="LCL" onCharges={(l) => fillChargesStore(chargesBookingStore1, "list", l, () => { cargoStore.calculateCargoTotals(); chargesBookingStore1.calculateLCLChargesTotals() })} /><AiChargeHistory scope="updateCost" chargeKey="list" />
                <div className="table-container" onClick={(e) => {
                    e.nativeEvent.preventDefault()
                    e.preventDefault()
                    e.nativeEvent.stopPropagation()
                    e.stopPropagation()

                }} >
                    <table style={{ border: "none", width: "100%" }}>
                        <thead>
                            {ifNotFCL() ?
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th colSpan='4' style={{ border: "solid 0.5px #4BA7DD", backgroundColor: "#4BA7DD", color: "#fff", fontWeight: "900", padding: "10px", textAlign: "center" }}>Per Unit</th>
                                    <th></th>
                                    <th ></th>
                                    <th></th>
                                </tr> : <></>
                            }
                            <tr style={{ fontWeight: "900", border: "solid 0.5px #D4D4D4" }}>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", width: '5rem' }}>ID</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", width: '20rem' }}>Charge Description</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>On Account</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Currency</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Per CBM</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Per Ton</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Minimum</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Maximum</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Per shipment</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right' }}>Total</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                imChargesStore.list
                                    .map((e, i) => {
                                        {
                                            if (e.chargeDescription == 'Volume Discount')
                                                return <></>
                                            else
                                                return <tr key={e.id} style={{ border: "solid 0.5px #D4D4D4", backgroundColor: (i % 2) == 1 ? "#F3F3F3" : "none" }}>
                                                    <td style={{ color: "#555555", padding: "10px" }}>{e.id}</td>
                                                    <td style={{ color: "#555555", padding: "10px" }}><Te i={i} name='chargeDescription' /></td>
                                                    <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='onaccount' dataList={onaccount} /></td>
                                                    <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='currency' dataList={configStore.getCurrencyList()} /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perCBM' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perTon' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='minimum' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='maximum' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perShipment' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'right' }}>{
                                                        (e.total != 0 && e.currency != '') ? Utils.N(e.total, e.currency) : ''
                                                    }</td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}>

                                                        <div className="field has-addons">
                                                            <p className="control">
                                                                <button className="button is-danger is-inverted"
                                                                    onClick={() => {
                                                                        deleteRec(e.id)
                                                                        setSpace(space === '' ? ' ' : '')
                                                                    }}>
                                                                    <span className="icon">
                                                                        <i className="fas fa-trash"></i>
                                                                    </span>
                                                                </button>
                                                            </p>
                                                            {
                                                                (i == imChargesStore.list.length - 1 || (JSON.stringify(chargesBookingStore1.list).indexOf('Volume Discount') != -1 && i == imChargesStore.list.length - 2)) ? <p className="control">
                                                                    <button className="button is-success is-inverted"
                                                                        onClick={() => {
                                                                            let obj = imChargesStore.newRec
                                                                            obj = { ...obj }
                                                                            chargesBookingStore1.list.push({ ...obj, id: imChargesStore.list.length + 1 })
                                                                            //chargesBookingStore1.calculateLCLChargesTotals()
                                                                            setSpace(space === '' ? ' ' : '')
                                                                        }}>
                                                                        <span className="icon is-small">
                                                                            <i className="fas fa-plus"></i>
                                                                        </span>
                                                                    </button>
                                                                </p> : ""
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>
                                        }
                                    }
                                    )
                            }
                            {!showtotal ? <tr style={{ border: "solid 0.5px #D4D4D4" }}><td colSpan={11} style={{ textAlign: 'right' }}>
                                <button className="button is-info is-inverted"

                                    onClick={(e) => {
                                        e.nativeEvent.preventDefault()
                                        e.preventDefault()
                                        e.nativeEvent.stopPropagation()
                                        e.stopPropagation()
                                        setVolumeDiscount(0)
                                        cargoStore.calculateCargoTotals()
                                        let voldis = imChargesStore.calculateLCLChargesTotals()
                                        calculateFinalTotal()
                                        setSpace(space === '' ? ' ' : '')
                                    }}>
                                    <span className="icon is-small">
                                        <i className="fas fa-calculator"></i>
                                    </span>
                                </button>
                            </td></tr> : ""}

                            {
                                showtotal ? <>
                                    <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                        <td colSpan={8}></td>
                                        <td colSpan={2} style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(grandTotal)}</strong></td>
                                        <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }} rowSpan={(conTotal && shipTotal && volumeDiscount) ? 6 : (volumeDiscount && (conTotal || shipTotal)) ? 5 : (volumeDiscount && !conTotal && !shipTotal) ? 4 : (conTotal && shipTotal) ? 4 : (conTotal || shipTotal) ? 3 : 2}>
                                            <button className="button is-info is-inverted"

                                                onClick={() => {
                                                    setVolumeDiscount(0)
                                                    cargoStore.calculateCargoTotals()
                                                    let voldis = imChargesStore.calculateLCLChargesTotals()
                                                    calculateFinalTotal()
                                                    setSpace(space === '' ? ' ' : '')
                                                }}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-calculator"></i>
                                                </span>
                                            </button>
                                        </td>
                                    </tr>
                                    {
                                        volumeDiscount != 0 &&
                                        <>
                                            <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                                <td colSpan={8} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Volume Discount :</td>
                                                <td colSpan={2} style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(volumeDiscount)}</strong></td>
                                            </tr>
                                            <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                                <td colSpan={8} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>TOTAL :</td>
                                                <td colSpan={2} style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(grandTotal + volumeDiscount)}</strong></td>
                                            </tr>
                                        </>
                                    }
                                    {
                                        shipTotal > 0 &&
                                        <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                            <td colSpan={9} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Total of On Shipper's Account : </td>
                                            <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(shipTotal)}</strong></td>
                                        </tr>
                                    }
                                    {
                                        conTotal > 0 &&
                                        <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                            <td colSpan={9} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Total of On Consignee's Account : </td>
                                            <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(conTotal)}</strong></td>
                                        </tr>
                                    }
                                </> : ""
                            }        {
                                imChargesStore.pkb
                                    .map((e, i) => {
                                        {
                                            if (e.chargeDescription == 'Volume Discount')
                                                return <></>
                                            else
                                                return <tr key={e.id} style={{ border: "solid 0.5px #D4D4D4", backgroundColor: (i % 2) == 1 ? "#F3F3F3" : "none" }}>
                                                    <td style={{ color: "#555555", padding: "10px" }}>{e.id}</td>
                                                    <td style={{ color: "#555555", padding: "10px" }}><Te i={i} name='chargeDescription' /></td>
                                                    <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='onaccount' dataList={onaccount} /></td>
                                                    <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='currency' dataList={configStore.getCurrencyList()} /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perCBM' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perTon' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='minimum' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='maximum' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perShipment' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'right' }}>{
                                                        (e.total != 0 && e.currency != '') ? Utils.N(e.total, e.currency) : ''
                                                    }</td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}>

                                                        <div className="field has-addons">
                                                            <p className="control">
                                                                <button className="button is-danger is-inverted"
                                                                    onClick={() => {
                                                                        deleteRec(e.id)
                                                                        setSpace(space === '' ? ' ' : '')
                                                                    }}>
                                                                    <span className="icon">
                                                                        <i className="fas fa-trash"></i>
                                                                    </span>
                                                                </button>
                                                            </p>
                                                            {
                                                                (i == imChargesStore.list.length - 1 || (JSON.stringify(chargesBookingStore1.list).indexOf('Volume Discount') != -1 && i == imChargesStore.list.length - 2)) ? <p className="control">
                                                                    <button className="button is-success is-inverted"
                                                                        onClick={() => {
                                                                            let obj = imChargesStore.newRec
                                                                            obj = { ...obj }
                                                                            chargesBookingStore1.list.push({ ...obj, id: imChargesStore.list.length + 1 })
                                                                            //chargesBookingStore1.calculateLCLChargesTotals()
                                                                            setSpace(space === '' ? ' ' : '')
                                                                        }}>
                                                                        <span className="icon is-small">
                                                                            <i className="fas fa-plus"></i>
                                                                        </span>
                                                                    </button>
                                                                </p> : ""
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>
                                        }
                                    }
                                    )
                            }
                        </tbody>
                    </table></div></Card>
        </>
    )
}

export function LCLChargesComp(props = {}) {
    const [grandTotal, setGrandTotal] = useState(0.0)
    const [shipTotal, setShipTotal] = useState(0.0)
    const [conTotal, setConTotal] = useState(0.0)
    const onaccount = ['On Your Account', `Consignee's Account`, `Shipper's Account`]
    const [volumeDiscount, setVolumeDiscount] = useState(0)
    const [showtotal, setShowtotal] = useState(false)
    const isEditingRef = useRef(false);

    useSnapshot(cargoStore)
    useSnapshot(contractsStore)
    console.log('ChargesComp rendering')
    let [space, setSpace] = useState('')

    let imChargesStore = useSnapshot(chargesBookingStore1)

    useEffect(() => {
        let list = chargesBookingStore1.list
        for (let i = 0; i < list.length; i++) {
            if (!list[i].onaccount || !list[i].onaccount.length) list[i].onaccount = 'On Your Account'
        }
        if (!grandTotal) {
            calculateFinalTotal()
            let vd = chargesBookingStore1.list.find(e => e.chargeDescription == 'Volume Discount')
            if (vd) {
                let of = chargesBookingStore1.list.filter(e => e.chargeDescription == 'Ocean Freight')
                if (of && of.length) {
                    if (vd.total > 0) vd.total *= -1
                    let voldis = vd.total
                    let e = of[0]
                    if (e.perCBM > 0 ||
                        e.perTon > 0 ||
                        e.minimum > 0 ||
                        e.maximum > 0 ||
                        e.perShipment > 0) {
                        e.perShipment = (e.total > 0 ? e.total : e.total * -1) + voldis
                        if (e.perShipment > 0) e.perShipment *= -1
                        console.log('\n\n\nSetting pershipment of OF to', e.perShipment, '\n-----------\n')
                    }
                }
            }
        }
    }, [imChargesStore])
    useEffect(() => {
        setVolumeDiscount(0)
        cargoStore.calculateCargoTotals()
        imChargesStore.calculateLCLChargesTotals()
        calculateFinalTotal()
    }, [imChargesStore.checktotal])
    useEffect(() => {
        const handler = (e) => {
            if (isEditingRef?.current) return;
            if (e.target.closest("input, textarea, select")) return;
            autoRecalculate();
        };

        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);
    useEffect(() => {
        let entity = EntityV2Store.list.find((e) => e.entityId === contractsStore.current.entityId)
        if (entity) {
            let sscope = contractsStore.current.shipmentScope
            sscope = sscope.toLowerCase()
            let country = '' + entity.entityCountry
            country = country.toLowerCase()
            let cecisorigin = false
            let cecisdestination = false
            let por = ('' + contractsStore.current.portOfLoading).toLowerCase()
            let pod = ('' + contractsStore.current.finalPlaceOfDelivery).toLowerCase()
            let q = contractsStore.current
            if (entity._id == "TBA" && q.isfromAgragaEnquiry != undefined && q.isfromAgragaEnquiry == 'Yes' && q.countryFromEnquiry != undefined) {
                country = q.countryFromEnquiry.toLowerCase()
            }
            if (country.includes('hong kong')) {
                cecisorigin = por.includes('hong kong')
                cecisdestination = pod.includes('hong kong')
            } else {
                cecisorigin = por.includes(country)
                cecisdestination = pod.includes(country)
            }

            chargesBookingStore1.list.map((e) => {
                if (sscope.length != 0 && country.length != 0 && por.length != 0 && pod.length != 0) {
                    if (e.onaccount != undefined) {
                        if (onaccount.indexOf(e.onaccount) == -1) {
                            e.onaccount = "On Your Account"
                        }
                    }
                }
                return e
            })
        }
        console.log('DETECTED CHANGES=', contractsStore.current.entityId, contractsStore.current.portOfReceipt, contractsStore.current.portOfDischarge)
    }, [
        contractsStore.current.entity, contractsStore.current.entityId, contractsStore.current.portOfLoading,
        contractsStore.current.finalPlaceOfDelivery, contractsStore.current.shipmentScope
    ])
    const deleteRec = (id) => {
        let records = [...chargesBookingStore1.list];
        const index = records.findIndex(e => e.id === id);
        if (index === -1) return;

        const deletedRecord = records[index];
        const deletedCategory = deletedRecord.category;

        records.splice(index, 1);

        const categoryStillExists = records.some(
            e => e.category === deletedCategory
        );

        if (!categoryStillExists) {
            let obj = { ...imChargesStore.newRec };
            obj.category = deletedCategory;
            obj.table = 1;
            records.push({
                ...obj,
                id: records.length + 1
            });
        }

        records.forEach((e, i) => {
            e.id = i + 1;
        });


        if (id <= chargesBookingStore1.initialLength) {
            chargesBookingStore1.initialLength = Math.max(
                0,
                chargesBookingStore1.initialLength - 1
            );
        }

        chargesBookingStore1.list = records;
        autoRecalculate()
    };

    const Ts = ({ id, name, dataList, tableNo, ...otherProps }) => {
        const table = getTableData(tableNo)
        const record = table.find(r => r.id === id)
        const index = table.findIndex(r => r.id === id)
        if (!record) return null;

        return (
            <UpdateCostTableSelect
                placeHolder="Select Currency"
                record={record}
                name={name}
                calculate={autoRecalculate}
                dataList={dataList}
                isValid={tableNo == 1 ? chargesBookingValidationStore.isValidCharge(name, index) : true}
                {...otherProps}
            />
        );
    };

    const Te = ({ id, name, tableNo, isEditingRef }) => {
        const table = getTableData(tableNo)

        const record = table.find(r => r.id === id)
        const index = table.findIndex(r => r.id === id)
        if (!record) return null;

        if (
            (name === 'chargeDescription' && record[name] != '' && index < chargesBookingStore1.initialLength) ||
            record.chargeDescription === 'Volume Discount'
        ) {
            return <TableLabel record={record} name={name} />;
        }

        return (
            <TableComboInput
                placeHolder="Select Description"
                record={record}
                name={name}
                dataList={configStore.getChargeDescriptionList('lcl')}
                isValid={tableNo == 1 ? chargesBookingValidationStore.isValidCharge(name, index) : true}
            />
            // <TableEdit
            //   isblue
            //   record={record}
            //   isEditingRef={isEditingRef}
            //   isreadonly={tableNo !== 1}
            //   name={name}
            //   isValid={tableNo == 1 ?chargesBookingValidationStore.isValidCharge(name, index):true}
            //   calculate={autoRecalculate}
            //   callback={(val) => {
            //     record[name] = val;
            //   }}
            // />
        );
    };

    const Tn = ({ id, name, tableNo, ...otherProps }) => {
        const table = getTableData(tableNo)
        const record = table.find(r => r.id === id)
        const index = table.findIndex(r => r.id === id)
        const currencyMissing = !record.currency;

        if (!record) return null;

        if (currencyMissing ||
            (record.disabled && record.disabled.includes(name)) ||
            record.chargeDescription === 'Volume Discount' || record.chargeDescription == 'Marine Insurance'
        ) {
            return (
                <input className="input is-small"
                    disabled
                    style={{
                        backgroundColor: '#dddddd',
                        border: 'none'
                    }}
                />
            );
        }

        return (
            <TableEdit
                record={record}
                calculate={autoRecalculate}
                name={name}
                type="number"
                isValid={tableNo == 1 ? chargesBookingValidationStore.isValidCharge(name, index) : true}
                {...otherProps}
            />
        );
    };

    const ifNotFCL = () => contractsStore.current.shipmentType.indexOf('FCL') < 0

    let finalTotal = 0.0
    const calculateFinalTotal = () => {
        let tot = 0
        let shiptot = 0
        let contot = 0
        chargesBookingStore1.list.map((e) => {
            let erate = configStore.getExchangeRateinr(e)
            if (!erate || erate === 0) erate = 1.0
            if (e.chargeDescription == 'Volume Discount') {
                if (e.total > 0) e.total *= -1
                setVolumeDiscount(e.total * erate)
            } else if (e.chargeDescription !== 'Rebate' && e.chargeDescription !== 'Freight Commission') {
                if (e.onaccount && e.onaccount.startsWith('Cons')) contot += e.total * erate
                else if (e.onaccount && e.onaccount.startsWith('Ship')) shiptot += e.total * erate
                else {
                    tot += e.total * erate
                }
            }
        })
        if (tot && showtotal == false) {
            setShowtotal(true)
        }
        setGrandTotal(tot)
        setShipTotal(shiptot)
        setConTotal(contot)
        return finalTotal;
    }
    const getTableData = (tableNo) => {
        switch (tableNo) {
            case 1: return chargesBookingStore1.list
            case 2: return chargesBookingStore1.rebate
            case 3: return chargesBookingStore1.pkb
            default: return []
        }
    }


    const autoRecalculate = () => {
        setVolumeDiscount(0);
        cargoStore.calculateCargoTotals();
        imChargesStore.calculateLCLChargesTotals();
        calculateFinalTotal();
        setShowtotal(true);
    };

    const emptyRecordCharges = (tableNo, categoryKey, desc) => {
        const obj = { ...imChargesStore.newRec };
        obj.category = categoryKey.toUpperCase();
        obj.table = tableNo;
        chargesBookingStore1[categoryKey.toLowerCase()] = [{
            ...obj,
            id: `temp-${categoryKey}-${Date.now()}`,
            chargeDescription: desc,
        }]
    }



    const chargesByTable = [chargesBookingStore1.list]
    const isEmpty = (val) =>
        val == null ||
        (Array.isArray(val) && val.length === 0) ||
        (typeof val === "object" && Object.keys(val).length === 0);
    // if(TenantUtils.isNavexel())


    // if (isEmpty(chargesBookingStore1.rebate)) {
    //   emptyRecordCharges(2, 'rebate', 'Rebate');
    // }

    // if (isEmpty(chargesBookingStore1.pkb)) {
    //   emptyRecordCharges(3, 'pkb', 'Freight Commission');
    // }

    // RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUOTATION.REBATE) && chargesByTable.push(chargesBookingStore1.rebate)
    // RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUOTATION.PKB) && chargesByTable.push(chargesBookingStore1.pkb);


    return (
        <>
            <hr />

            {Object.entries(chargesByTable).map(([tableNo, tableCharges]) => {
                tableNo = Number(tableNo) + 1;
                const groupedCharges = groupedByCategory(tableCharges);

                return (
                    <Card key={tableNo} style={{ marginBottom: "24px" }}>
                        {tableNo == 1 && <div><span><img style={{ paddingTop: '10px' }} src={chargedetails} /></span>
                            <Headspan
                                color="#000"
                                fontSize="14px"
                                fontWeight="900"
                                data={`  Charge Details`}
                            /><AiChargeParse historyScope={props.aiScope || "updateCost"} historyKey="list" shipmentType="LCL" onCharges={(l) => fillChargesStore(chargesBookingStore1, "list", l, () => { cargoStore.calculateCargoTotals(); chargesBookingStore1.calculateLCLChargesTotals() })} /><AiChargeHistory scope={props.aiScope || "updateCost"} chargeKey="list" /></div>}

                        <div className="table-container">
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    {ifNotFCL() && (
                                        <tr>
                                            <th></th><th></th><th></th><th></th>
                                            {tableNo == 1 && <th colSpan="4"
                                                style={{
                                                    background: "#4BA7DD",
                                                    color: "#fff",
                                                    fontWeight: 900,
                                                    padding: "10px",
                                                    textAlign: "center"
                                                }}>
                                                Per Unit
                                            </th>}
                                            <th></th><th></th><th></th>
                                        </tr>
                                    )}

                                    <tr style={{ fontWeight: 900, border: "1px solid #D4D4D4" }}>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>#</th>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Charge Description</th>
                                        {tableNo == 1 && <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>On Account</th>}
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Currency</th>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Per CBM</th>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Per Ton</th>
                                        {tableNo === 1 ? <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Minimum</th> : <></>}
                                        {tableNo === 1 ? <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Maximum</th> : <></>}
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Per Shipment</th>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: "right" }}>Total</th>
                                        {tableNo == 1 && <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Action</th>}
                                    </tr>
                                </thead>

                                <tbody>
                                    {Object.entries(groupedCharges).map(([categoryKey, charges]) => (
                                        <Fragment key={categoryKey}>
                                            <tr>
                                                <td colSpan={11}
                                                    style={{
                                                        background: "#EAF4FB",
                                                        fontWeight: 900,
                                                        padding: "10px",
                                                        color: "#1E4E79",
                                                        border: "1px solid #4BA7DD"
                                                    }}>
                                                    {PRICING_CATEGORY[categoryKey]?.label}
                                                </td>
                                            </tr>

                                            {charges.map((e, i) => (
                                                <tr key={e.id}
                                                    style={{
                                                        background: i % 2 ? "#F3F3F3" : "transparent",
                                                        border: "1px solid #D4D4D4"
                                                    }}>
                                                    <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>{i + 1}</td>
                                                    <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}><Te id={e.id} isEditingRef={isEditingRef} name="chargeDescription" tableNo={tableNo} /></td>
                                                    {tableNo == 1 && <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}><Ts id={e.id} name="onaccount" dataList={onaccount} tableNo={tableNo} /></td>}
                                                    <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}><Ts id={e.id} name="currency" dataList={configStore.getCurrencyList()} tableNo={tableNo} /></td>
                                                    <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}><Tn id={e.id} name="perCBM" tableNo={tableNo} /></td>
                                                    <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}><Tn id={e.id} name="perTon" tableNo={tableNo} /></td>
                                                    {tableNo === 1 ? <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}><Tn id={e.id} name="minimum" tableNo={tableNo} /></td> : <></>}
                                                    {tableNo === 1 ? <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}><Tn id={e.id} name="maximum" tableNo={tableNo} /></td> : <></>}
                                                    <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}><Tn id={e.id} name="perShipment" tableNo={tableNo} /></td>
                                                    <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: "right" }}>
                                                        {e.total && e.currency ? Utils.N(e.total, e.currency) : ""}
                                                    </td>
                                                    {tableNo == 1 && <td style={{ textAlign: "center" }}>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                gap: "8px"
                                                            }}
                                                        >
                                                            {(e.chargeDescription != 'Marine Insurance') && <button
                                                                className="button is-danger is-inverted"
                                                                onClick={() => deleteRec(e.id)}
                                                            >
                                                                <i className="fas fa-trash" />
                                                            </button>
                                                            }
                                                            {i === charges.length - 1 ? (
                                                                <button
                                                                    className="button is-success is-inverted"
                                                                    onClick={() => {
                                                                        const obj = { ...imChargesStore.newRec };
                                                                        obj.category = categoryKey;
                                                                        obj.table = tableNo;
                                                                        chargesBookingStore1.list.push({
                                                                            ...obj,
                                                                            id: chargesBookingStore1.list[chargesBookingStore1.list.length - 1].id + 1
                                                                        });
                                                                        setSpace(space === "" ? " " : "");
                                                                    }}
                                                                >
                                                                    <i className="fas fa-plus" />
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className="button is-success is-inverted"
                                                                    style={{ visibility: "hidden" }}
                                                                >
                                                                    <i className="fas fa-plus" />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>}

                                                </tr>
                                            ))}
                                        </Fragment>
                                    ))}
                                </tbody>

                                {!showtotal ? <tr style={{ border: "solid 0.5px #D4D4D4" }}><td colSpan={11} style={{ textAlign: 'right' }}>
                                </td></tr> : ""}

                                {
                                    showtotal && tableNo == 1 ? <>
                                        <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                            <td colSpan={8}></td>
                                            <td colSpan={2} style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(grandTotal)}</strong></td>
                                            <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }} rowSpan={(conTotal && shipTotal && volumeDiscount) ? 6 : (volumeDiscount && (conTotal || shipTotal)) ? 5 : (volumeDiscount && !conTotal && !shipTotal) ? 4 : (conTotal && shipTotal) ? 4 : (conTotal || shipTotal) ? 3 : 2}>

                                            </td>
                                        </tr>
                                        {
                                            volumeDiscount != 0 &&
                                            <>
                                                <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                                    <td colSpan={8} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Volume Discount :</td>
                                                    <td colSpan={2} style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(volumeDiscount)}</strong></td>
                                                </tr>
                                                <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                                    <td colSpan={8} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>TOTAL :</td>
                                                    <td colSpan={2} style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(grandTotal + volumeDiscount)}</strong></td>
                                                </tr>
                                            </>
                                        }
                                        {
                                            shipTotal > 0 &&
                                            <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                                <td colSpan={9} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Total of On Shipper's Account : </td>
                                                <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(shipTotal)}</strong></td>
                                            </tr>
                                        }
                                        {
                                            conTotal > 0 &&
                                            <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                                <td colSpan={9} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Total of On Consignee's Account : </td>
                                                <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(conTotal)}</strong></td>
                                            </tr>
                                        }
                                    </> : tableNo !== 1 && <td colSpan={11} style={{ textAlign: 'right' }}><button className="button is-info is-inverted"

                                        onClick={() => {
                                            setVolumeDiscount(0)
                                            cargoStore.calculateCargoTotals()
                                            let voldis = imChargesStore.calculateLCLChargesTotals()
                                            calculateFinalTotal()
                                            setSpace(space === '' ? ' ' : '')
                                        }}>

                                    </button></td>

                                }




                            </table>
                        </div>
                    </Card>
                );
            })}
        </>

    )
}

export function AirChargesComp(props) {
    const [grandTotal, setGrandTotal] = useState(0.0)
    const [shipTotal, setShipTotal] = useState(0.0)
    const [conTotal, setConTotal] = useState(0.0)
    const onaccount = ['On Your Account', `Consignee's Account`, `Shipper's Account`]
    useSnapshot(contractsStore)
    console.log('ChargesComp rendering')
    let [space, setSpace] = useState('')

    let key = "list"
    if (props.keylist != undefined) {
        key = props.keylist
    }
    let initialLength = "initialLength" + key.replace("list", "")
    let imChargesStore = useSnapshot(airChargesBookingStore)


    useEffect(() => {
        let list = airChargesBookingStore[key]
        for (let i = 0; i < list.length; i++) {
            if (!list[i].onaccount || !list[i].onaccount.length) list[i].onaccount = 'On Your Account'
        }
        if (!grandTotal) {
            calculateFinalTotal()
        }
    }, [imChargesStore])
    useEffect(() => {
        cargoStore.calculateCargoTotals()
        airChargesBookingStore.calculateChargesTotalsindex(key)
        calculateFinalTotal()
    }, [imChargesStore.checktotal])
    useEffect(() => {
        let entity = EntityV2Store.list.find((e) => e.entityId === contractsStore.current.entityId)
        if (entity) {
            let sscope = contractsStore.current.shipmentScope
            sscope = sscope.toLowerCase()
            let country = '' + entity.entityCountry
            country = country.toLowerCase()
            let cecisorigin = false
            let cecisdestination = false
            let por = ('' + contractsStore.current.portOfLoading).toLowerCase()
            let pod = ('' + contractsStore.current.finalPlaceOfDelivery).toLowerCase()
            let q = contractsStore.current
            if (entity._id == "TBA" && q.isfromAgragaEnquiry != undefined && q.isfromAgragaEnquiry == 'Yes' && q.countryFromEnquiry != undefined) {
                country = q.countryFromEnquiry.toLowerCase()
            }
            if (country.includes('hong kong')) {
                cecisorigin = por.includes('hong kong')
                cecisdestination = pod.includes('hong kong')
            } else {
                cecisorigin = por.includes(country)
                cecisdestination = pod.includes(country)
            }
            airChargesBookingStore[key].map((e, i) => {
                if (sscope.length != 0 && country.length != 0 && por.length != 0 && pod.length != 0) {
                    if (e.onaccount != undefined) {
                        if (onaccount.indexOf(e.onaccount) == -1) {
                            e.onaccount = "On Your Account"
                        }
                    }
                }
                return e
            })
        }
        console.log('DETECTED CHANGES=', contractsStore.current.entityId, contractsStore.current.portOfReceipt, contractsStore.current.portOfDischarge)
    }, [
        contractsStore.current.entity, contractsStore.current.entityId, contractsStore.current.portOfLoading,
        contractsStore.current.portOfDischarge, contractsStore.current.shipmentScope
    ])
    const deleteRec = (id) => {
        //if (id <= imChargesStore[initialLength]) return
        const index = airChargesBookingStore[key].findIndex(e => e.id === id)
        let records = airChargesBookingStore[key]
        records = [...records]
        records.splice(index, 1)
        for (let i = 0; i < records.length; i++) {
            records[i].id = i + 1
        }
        if (id <= airChargesBookingStore[initialLength]) {
            airChargesBookingStore[initialLength] = airChargesBookingStore[initialLength] - 1
        }
        airChargesBookingStore[key] = records
        if (airChargesBookingStore[key].length == 0) {
            let obj = imChargesStore.newRec
            obj = { ...obj }
            airChargesBookingStore[key].push({ ...obj, id: airChargesBookingStore[key].length + 1 })
        }
    }
    const Ts = ({ i, name, dataList }) => <UpdateCostTableSelect
        record={airChargesBookingStore[key][i]} name={name} dataList={dataList} isValid={chargesBookingValidationStore.isValidCharge(name, i, key)} />
    const Te = ({ i, name }) => {
        const e = airChargesBookingStore[key][i]
        if (name === 'chargeDescription' && i < airChargesBookingStore[initialLength])
            return <TableLabel record={airChargesBookingStore[key][i]} name={name} />
        return (
            <TableComboInput
                record={airChargesBookingStore[key][i]} name={name} dataList={configStore.getChargeDescriptionList('air')} isValid={chargesBookingValidationStore.isValidCharge(name, i, key)} />
            // <TableEdit record={airChargesBookingStore[key][i]} name={name} isValid={chargesBookingValidationStore.isValidCharge(name, i,key)}/>
        )
    }
    const Tn = ({ i, name }) => {
        const e = airChargesBookingStore[key][i]
        if (e.disabled && e.disabled.indexOf(name) >= 0 && props.type !== 'Edit Charges')
            return (
                <input disabled='true' style={{ backgroundColor: '#dddddd', border: 'none' }} />
            )
        else return (
            <TableEdit record={airChargesBookingStore[key][i]} name={name} type='number' isValid={chargesBookingValidationStore.isValidCharge(name, i, key)} />
        )
    }

    const ifNotFCL = () => contractsStore.current.shipmentType.indexOf('FCL') < 0

    let finalTotal = 0.0
    const calculateFinalTotal = () => {
        let tot = 0
        let shiptot = 0
        let contot = 0
        airChargesBookingStore[key].map((e) => {
            let erate = configStore.getExchangeRateinr(e)
            if (!erate || erate === 0) erate = 1.0
            if (e.onaccount && e.onaccount.startsWith('Cons')) contot += e.total * erate
            else if (e.onaccount && e.onaccount.startsWith('Ship')) shiptot += e.total * erate
            else {
                tot += e.total * erate
            }
        })
        if (tot) {
            setGrandTotal(tot)
            setShipTotal(shiptot)
            setConTotal(contot)
        }
        return finalTotal
    }

    return (
        <>
            <hr />
            <Card onClick={(e) => {
                e.nativeEvent.preventDefault()
                e.preventDefault()
                e.nativeEvent.stopPropagation()
                e.stopPropagation()

            }} >
                <span><img src={chargedetails} /></span><Headspan color="#00000" fontSize="14px" fontWeight="900" data={" Charge Details" + (props.heading != undefined && props.heading.length > 0 ? " - " + props.heading : "")} />
                <AiChargeParse historyScope={props.aiScope || "updateCost"} historyKey={key} shipmentType="Air" onCharges={(l) => fillChargesStore(airChargesBookingStore, key, l, () => { cargoStore.calculateCargoTotals(); airChargesBookingStore.calculateChargesTotalsindex(key) })} /><AiChargeHistory scope={props.aiScope || "updateCost"} chargeKey={key} />
                <div className="table-container" onClick={(e) => {
                    e.nativeEvent.preventDefault()
                    e.preventDefault()
                    e.nativeEvent.stopPropagation()
                    e.stopPropagation()

                }} >
                    <table style={{ border: "none", width: "100%" }}>
                        <thead>

                            {ifNotFCL() ?
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th colSpan='2' style={{ border: "solid 0.5px #4BA7DD", backgroundColor: "#4BA7DD", color: "#fff", fontWeight: "900", padding: "10px", textAlign: "center" }} >Per Unit</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr> : <></>
                            }
                            <tr style={{ fontWeight: "900", border: "solid 0.5px #D4D4D4" }}>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>ID</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", width: '20rem' }}>Charge Description</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>On Account</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Currency</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Per Kg</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Minimum</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Per AWB</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right' }}>Total</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                imChargesStore[key].map((e, i) => {
                                    {
                                        return <tr key={e.id} style={{ border: "solid 0.5px #D4D4D4", backgroundColor: (i % 2) == 1 ? "#F3F3F3" : "none" }}>
                                            <td style={{ color: "#555555", padding: "10px" }}>{e.id}</td>
                                            <td style={{ color: "#555555", padding: "10px" }}><Te i={i} name='chargeDescription' /></td>
                                            <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='onaccount' dataList={onaccount} /></td>
                                            <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='currency' dataList={configStore.getCurrencyList()} /></td>
                                            <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perKg' /></td>
                                            <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='minimum' /></td>
                                            <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perAWB' /></td>
                                            <td style={{ color: "#555555", padding: "10px", textAlign: 'right' }}>{
                                                (e.total != 0 && e.currency != '') ? Utils.N(e.total, e.currency) : ''
                                            }</td>
                                            <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}>
                                                <div className="field has-addons">

                                                    <p className="control">
                                                        <button className="button is-danger is-inverted"
                                                            onClick={() => {
                                                                deleteRec(e.id)
                                                                setSpace(space === '' ? ' ' : '')
                                                            }}>
                                                            <span className="icon">
                                                                <i className="fas fa-trash"></i>
                                                            </span>
                                                        </button>
                                                    </p>

                                                    {
                                                        i === imChargesStore[key].length - 1 &&
                                                        (
                                                            <p className="control">
                                                                <button className="button is-success is-inverted"
                                                                    onClick={() => {
                                                                        let obj = imChargesStore.newRec
                                                                        obj = { ...obj }
                                                                        airChargesBookingStore[key].push({ ...obj, id: imChargesStore[key].length + 1 })
                                                                        setSpace(space === '' ? ' ' : '')
                                                                    }}>
                                                                    <span className="icon is-small">
                                                                        <i className="fas fa-plus"></i>
                                                                    </span>
                                                                </button>
                                                            </p>
                                                        )
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                }
                                )
                            }
                            <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                <td colSpan={7} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Total of On Your Account : </td>
                                <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(grandTotal)}</strong></td>
                                <td rowSpan={(conTotal && shipTotal) ? 4 : (conTotal || shipTotal) ? 3 : 2} style={{ textAlign: 'center' }}>
                                    <button className="button is-info is-inverted"

                                        onClick={(e) => {
                                            e.nativeEvent.preventDefault()
                                            e.preventDefault()
                                            e.nativeEvent.stopPropagation()
                                            e.stopPropagation()

                                            cargoStore.calculateCargoTotals()
                                            airChargesBookingStore.calculateChargesTotalsindex(key)
                                            calculateFinalTotal()
                                            setSpace(space === '' ? ' ' : '')
                                        }}>
                                        <span className="icon is-small">
                                            <i className="fas fa-calculator"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                            {
                                shipTotal > 0 &&
                                <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                    <td colSpan={7} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Total of On Shipper's Account : </td>
                                    <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(shipTotal)}</strong></td>
                                </tr>
                            }
                            {
                                conTotal > 0 &&
                                <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                    <td colSpan={7} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Total of On Consignee's Account : </td>
                                    <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(conTotal)}</strong></td>
                                </tr>
                            }
                        </tbody>
                    </table></div></Card>
        </>
    )
}

export function FCLChargesComp(props) {

    const onaccount = ['On Your Account', `Consignee's Account`, `Shipper's Account`]
    useSnapshot(contractsStore)
    let key = "list"
    if (props.keylist != undefined) {
        key = props.keylist
    }
    let initialLength = "initialLength" + key.replace("list", "")
    const imContainerStore = useSnapshot(containerStore)
    const containerNames = imContainerStore.list.map(e => e.containerType)
    let [space, setSpace] = useState('')
    if (fclChargesBookingStore[key].length > 0) {
        let oldchargeskey = []
        Object.entries(fclChargesBookingStore[key][0]).filter(([key, value]) => {
            oldchargeskey.push(key)
        })
        let newchargeskey = []
        oldchargeskey.map(e => {
            if (e.indexOf("'") == -1) {
                newchargeskey.push(e)
            } else {
                containerNames.map(f => {
                    if (e.indexOf(f) > -1) {
                        newchargeskey.push(e)
                    }
                })
            }
        })
        let uniqueContainer = new Set(containerNames)
        if (oldchargeskey.sort().toString() != newchargeskey.sort().toString() && containerNames.length === uniqueContainer.size) {
            let newchargelist = []
            fclChargesBookingStore[key].map((e) => {
                var result = Object.fromEntries(newchargeskey.map(col => [col, e[col]]));
                newchargelist.push(result)
            })
            fclChargesBookingStore[key] = newchargelist;
        }

    }

    let imChargesStore = useSnapshot(fclChargesBookingStore)
    let a = imChargesStore.newRec
    let b = imChargesStore.editRec

    let list = fclChargesBookingStore[key]
    for (let i = 0; i < list.length; i++) {
        if (!list[i].onaccount || !list[i].onaccount.length) list[i].onaccount = 'On Your Account'
    }
    useEffect(() => {
        let entity = EntityV2Store.list.find((e) => e.entityId === contractsStore.current.entityId)
        if (entity) {
            let sscope = contractsStore.current.shipmentScope
            sscope = sscope.toLowerCase()
            let country = '' + entity.entityCountry
            country = country.toLowerCase()
            let cecisorigin = false
            let cecisdestination = false
            let por = ('' + contractsStore.current.portOfLoading).toLowerCase()
            let pod = ('' + contractsStore.current.finalPlaceOfDelivery).toLowerCase()
            let q = contractsStore.current
            if (entity._id == "TBA" && q.isfromAgragaEnquiry != undefined && q.isfromAgragaEnquiry == 'Yes' && q.countryFromEnquiry != undefined) {
                country = q.countryFromEnquiry.toLowerCase()
            }
            if (country.includes('hong kong')) {
                cecisorigin = por.includes('hong kong')
                cecisdestination = pod.includes('hong kong')
            } else {
                cecisorigin = por.includes(country)
                cecisdestination = pod.includes(country)
            }

            fclChargesBookingStore[key].map((e) => {
                if (sscope.length != 0 && country.length != 0 && por.length != 0 && pod.length != 0) {
                    if (e.onaccount != undefined) {
                        if (onaccount.indexOf(e.onaccount) == -1) {
                            e.onaccount = "On Your Account"
                        }
                    }
                }
                return e
            })
        }
        console.log('DETECTED CHANGES=', contractsStore.current.entityId, contractsStore.current.portOfReceipt, contractsStore.current.portOfDischarge)
    }, [
        contractsStore.current.entity, contractsStore.current.entityId, contractsStore.current.portOfLoading,
        contractsStore.current.finalPlaceOfDelivery, contractsStore.current.shipmentScope
    ])
    const deleteRec = (id) => {
        //if (id <= imChargesStore[initialLength]) return
        const index = fclChargesBookingStore[key].findIndex(e => e.id === id)
        let records = fclChargesBookingStore[key]
        records = [...records]
        records.splice(index, 1)
        for (let i = 0; i < records.length; i++) {
            records[i].id = i + 1
        }
        if (id <= fclChargesBookingStore[initialLength]) {
            fclChargesBookingStore[initialLength] = fclChargesBookingStore[initialLength] - 1
        }
        fclChargesBookingStore[key] = records
        if (fclChargesBookingStore[key].length == 0) {
            let obj = imChargesStore.newRec
            obj = { ...obj }
            fclChargesBookingStore[key].push({ ...obj, id: fclChargesBookingStore[key].length + 1 })
        }
        //console.log('AFTER DELETE=', JSON.stringify(fclChargesBookingStore.cargoList))
    }
    const Ts = ({ i, name, dataList }) => <UpdateCostTableSelect
        record={fclChargesBookingStore[key][i]} name={name} dataList={dataList} isValid={chargesBookingValidationStore.isValidCharge(name, i, key)} />
    const Te = ({ i, name }) => {
        const e = fclChargesBookingStore[key][i]
        if (name === 'chargeDescription' && i < fclChargesBookingStore[initialLength])
            return <TableLabel record={fclChargesBookingStore[key][i]} name={name} />
        return (
            <TableComboInput
                record={fclChargesBookingStore[key][i]} name={name} dataList={configStore.getChargeDescriptionList('fcl')} isValid={chargesBookingValidationStore.isValidCharge(name, i, key)} />
            // <TableEdit record={fclChargesBookingStore[key][i]} name={name} isValid={chargesBookingValidationStore.isValidCharge(name, i,key)}/>
        )
    }
    const Tn = ({ i, name }) => {
        const e = fclChargesBookingStore[key][i]
        let disabled = false
        if (e.disabled && props.type !== 'Edit Charges') {
            for (let i = 0; i < e.disabled.length; i++) {
                if (name.endsWith(e.disabled[i])) {
                    disabled = true
                    break
                }
            }
        }
        if (disabled)
            return (
                <input disabled='true' style={{ width: '3rem', backgroundColor: '#dddddd', border: 'none' }} />
            )
        else return (
            <TableEdit record={fclChargesBookingStore[key][i]} name={name} type='number' isValid={chargesBookingValidationStore.isValidCharge(name, i, key)} />
        )
    }

    let grandTotal = {}
    let cTotal = {}
    let sTotal = {}
    let cPresent = false
    let sPresent = false
    containerStore.list.map(c => {
        grandTotal[c.containerType] = 0.0
        cTotal[c.containerType] = 0.0
        sTotal[c.containerType] = 0.0
    })
    fclChargesBookingStore[key].map(e => {
        let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        containerStore.list.map(c => {
            let totalField = c.containerType + 'total'
            if (e.onaccount && e.onaccount.startsWith('Cons')) {
                cPresent = true
                cTotal[c.containerType] += parseFloat(e[totalField]) * erate
            }
            else if (e.onaccount && e.onaccount.startsWith('Ship')) {
                sPresent = true
                sTotal[c.containerType] += parseFloat(e[totalField]) * erate
            }
            else grandTotal[c.containerType] += parseFloat(e[totalField]) * erate
        })
    })
    if (fclChargesBookingStore[key].length > 0) {
        fclChargesBookingStore.defaultValueCalcindex(key) // Need to calculate for validation
    }
    return (
        <>
            <hr />
            <Card onClick={(e) => {
                e.nativeEvent.preventDefault()
                e.preventDefault()
                e.nativeEvent.stopPropagation()
                e.stopPropagation()

            }} >
                <span><img src={chargedetails} /></span><Headspan color="#00000" fontSize="14px" fontWeight="900" data={" Charge Details" + (props.heading != undefined && props.heading.length > 0 ? " - " + props.heading : "")} />
                <AiChargeParse historyScope={props.aiScope || "updateCost"} historyKey={key} shipmentType="FCL" containerTypes={containerNames} onCharges={(l) => fillChargesStore(fclChargesBookingStore, key, l, () => fclChargesBookingStore.calculateChargesTotalsindex(key, contractsStore.current.emptycontainerweight))} /><AiChargeHistory scope={props.aiScope || "updateCost"} chargeKey={key} />
                <div className="table-container" onClick={(e) => {
                    e.nativeEvent.preventDefault()
                    e.preventDefault()
                    e.nativeEvent.stopPropagation()
                    e.stopPropagation()

                }} >
                    <table style={{ border: "none", width: "100%" }}>
                        <thead>
                            {
                                (containerNames.length > 0) ? <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    {containerNames.map(e => (
                                        <>
                                            <td style={{ border: "solid 0.5px #4BA7DD", backgroundColor: "#4BA7DD", color: "#fff", fontWeight: "900", padding: "10px", textAlign: "center" }} colSpan={3}>{e}</td>
                                            <th></th>
                                        </>
                                    ))}
                                    <th></th>
                                </tr> : ""
                            }
                            <tr style={{ fontWeight: "900", border: "solid 0.5px #D4D4D4" }}>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>ID</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Charge Description</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>On Account</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Currency</th>
                                {containerNames.map(e => (
                                    <>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Per Container</th>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Per BL</th>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Per Ton</th>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right' }}>Total</th>
                                    </>
                                ))}
                                {
                                    (containerNames.length > 0) ?
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Action</th> : ""}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                imChargesStore[key].map((e, i) => {
                                    {
                                        return <tr key={e.id} style={{ border: "solid 0.5px #D4D4D4", backgroundColor: (i % 2) == 1 ? "#F3F3F3" : "none" }}>
                                            <td style={{ color: "#555555", padding: "10px" }}>{i + 1}</td>
                                            <td style={{ color: "#555555", padding: "10px" }}><Te i={i} name='chargeDescription' /></td>
                                            <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='onaccount' dataList={onaccount} /></td>
                                            <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='currency' dataList={currencyList} /></td>
                                            {containerNames.map(e1 => (
                                                <>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name={e1 + 'perWM'} /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name={e1 + 'perShipment'} /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name={e1 + 'perTon'} /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'right' }}>
                                                        {
                                                            (e[e1 + 'total'] != 0 && e.currency != '') ?
                                                                Utils.N(e[e1 + 'total'], e.currency) : ''
                                                        }
                                                    </td>
                                                </>
                                            ))}
                                            {
                                                (containerNames.length > 0) ?
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}>
                                                        <div className="field has-addons">


                                                            <p className="control">
                                                                <button className="button is-danger is-inverted"
                                                                    onClick={() => {
                                                                        deleteRec(e.id)
                                                                        setSpace(space === '' ? ' ' : '')
                                                                    }}>
                                                                    <span className="icon">
                                                                        <i className="fas fa-trash"></i>
                                                                    </span>
                                                                </button>
                                                            </p>

                                                            {
                                                                i === imChargesStore[key].length - 1 && (
                                                                    <p className="control">
                                                                        <button className="button is-success is-inverted"
                                                                            onClick={(e) => {
                                                                                e.nativeEvent.preventDefault()
                                                                                e.preventDefault()
                                                                                e.nativeEvent.stopPropagation()
                                                                                e.stopPropagation()
                                                                                let obj = imChargesStore.newRec
                                                                                obj = { ...obj }
                                                                                fclChargesBookingStore[key].push({ ...obj, id: imChargesStore[key].length + 1 })
                                                                                imChargesStore.defaultValueCalcindex(key)
                                                                                setSpace(space === '' ? ' ' : '')
                                                                            }}>
                                                                            <span className="icon is-small">
                                                                                <i className="fas fa-plus"></i>
                                                                            </span>
                                                                        </button>
                                                                    </p>
                                                                )
                                                            }
                                                        </div>
                                                    </td> : ""
                                            }

                                        </tr>
                                    }
                                }
                                )
                            }
                            {
                                (containerNames.length > 0) ? <>
                                    <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                        <td colSpan={4} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>On Your Account</td>
                                        {
                                            containerStore.list.map(c => {
                                                return (
                                                    <>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td style={{ textAlign: 'right' }}>
                                                            <strong>
                                                                {Utils.N(grandTotal[c.containerType])}
                                                            </strong>
                                                        </td>
                                                    </>
                                                )
                                            })
                                        }
                                        <td rowSpan={(cPresent && sPresent) ? 4 : (cPresent || sPresent) ? 3 : 2} style={{ textAlign: 'center' }}>
                                            <button className="button is-info is-inverted"

                                                onClick={() => {
                                                    fclChargesBookingStore.calculateChargesTotalsindex(key, contractsStore.current.emptycontainerweight);
                                                    setSpace(space === '' ? ' ' : '')
                                                }}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-calculator"></i>
                                                </span>
                                            </button>
                                        </td>
                                    </tr>
                                    {
                                        cPresent &&
                                        <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                            <td colSpan={4} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>On Consignee's Account</td>
                                            {
                                                containerStore.list.map(c => {
                                                    return (
                                                        <>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}>
                                                                <strong>
                                                                    {Utils.N(cTotal[c.containerType])}
                                                                </strong>
                                                            </td>
                                                        </>
                                                    )
                                                })
                                            }
                                        </tr>
                                    }
                                    {
                                        sPresent &&
                                        <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                            <td colSpan={4} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>On Shipper's Account</td>
                                            {
                                                containerStore.list.map(c => {
                                                    return (
                                                        <>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}>
                                                                <strong>
                                                                    {Utils.N(sTotal[c.containerType])}
                                                                </strong>
                                                            </td>
                                                        </>
                                                    )
                                                })
                                            }
                                        </tr>
                                    }
                                </> : ""}

                        </tbody>
                    </table></div></Card>
        </>
    )
}
